import { render, staticRenderFns } from "./UserManagementView.vue?vue&type=template&id=6d012f52&scoped=true"
import script from "./UserManagementView.vue?vue&type=script&lang=js"
export * from "./UserManagementView.vue?vue&type=script&lang=js"
import style0 from "./UserManagementView.vue?vue&type=style&index=0&id=6d012f52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d012f52",
  null
  
)

export default component.exports